var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUnderline18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.148 11.844c.768-.736 1.152-1.856 1.152-3.36V1h-2.112v7.5c0 .95-.179 1.64-.536 2.072-.357.432-.912.648-1.664.648-.741 0-1.29-.216-1.648-.648-.352-.432-.528-1.123-.528-2.072V1H4.7v7.484c0 1.504.381 2.624 1.144 3.36.763.736 1.81 1.104 3.144 1.104 1.344 0 2.397-.368 3.16-1.104zM14 16H4v2h10v-2z"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiPjxwYXRoIGQ9Ik0xMi4xNDggMTEuODQ0Yy43NjgtLjczNiAxLjE1Mi0xLjg1NiAxLjE1Mi0zLjM2VjFoLTIuMTEydjcuNWMwIC45NS0uMTc5IDEuNjQtLjUzNiAyLjA3Mi0uMzU3LjQzMi0uOTEyLjY0OC0xLjY2NC42NDgtLjc0MSAwLTEuMjktLjIxNi0xLjY0OC0uNjQ4LS4zNTItLjQzMi0uNTI4LTEuMTIzLS41MjgtMi4wNzJWMUg0Ljd2Ny40ODRjMCAxLjUwNC4zODEgMi42MjQgMS4xNDQgMy4zNi43NjMuNzM2IDEuODEgMS4xMDQgMy4xNDQgMS4xMDQgMS4zNDQgMCAyLjM5Ny0uMzY4IDMuMTYtMS4xMDR6TTE0IDE2SDR2MmgxMHYtMnoiLz48L3N2Zz4=";
export { SvgUnderline18 as ReactComponent };